export const API_URL = process.env.REACT_APP_API_URL || 'http://192.168.1.37:8012/api';

// Ortak fetch fonksiyonu
export const fetchApi = async (endpoint: string, options: RequestInit = {}) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

// Dosya yükleme için özel fetch fonksiyonu
export const uploadFile = async (endpoint: string, formData: FormData) => {
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
}; 